import { create } from "../../../../../common/utils/zustand_state_manager";

/**
 * useCategoriaAssistenciaListaFilters
 */

type State = {
  field: number | null;
  value: string | null;
  status: number | null;
};

type Actions = {
};

export const useCategoriaAssistenciaListaFilters = create<State & Actions>((set) => ({
  field: 1,
  value: null,
  status: 2,
}));

export const initialCategoriaAssistenciaListaFiltersState: State = {
  field: 1,
  value: null,
  status: 2,
};